export const getNameFormValue = (value = '') => {
  if (!value) {
    return '';
  }

  return value.length === 1 ? value.toUpperCase() : value;
};
